// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27af1369","952":"3bca283c"}[chunkId] + ".chunk.js";
};